var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGotToDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 83,
    viewBox: "0 0 9 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00098 41.5C9.00098 41.2925 8.91797 41.1016 8.76025 40.9521L2.18604 34.5107C2.03662 34.3696 1.854 34.2949 1.63818 34.2949C1.21484 34.2949 0.882812 34.6187 0.882812 35.0503C0.882812 35.2578 0.96582 35.4487 1.09863 35.5898L7.1416 41.5L1.09863 47.4102C0.96582 47.5513 0.882812 47.7339 0.882812 47.9497C0.882812 48.3813 1.21484 48.7051 1.63818 48.7051C1.854 48.7051 2.03662 48.6304 2.18604 48.481L8.76025 42.0479C8.91797 41.8901 9.00098 41.7075 9.00098 41.5Z",
    fill: "#3C3C43",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGotToDetails);
export default __webpack_public_path__ + "static/media/got-to-details.2a929a078d923778c79381ac3acf8d12.svg";
export { ForwardRef as ReactComponent };